import type { CommerceOperationOptions, CommerceOrder } from "@teqtank/commerce-contracts";
import { CommerceRepository } from "../repositories/commerce-repository.js";
import { getCommerceOrderOperation } from "../operations/get-commerce-order-operation.js";
import { refreshCommerceOrderOperation } from "../operations/refresh-commerce-order-operation.js";
import { resolveCommerceOrder } from "./order-response-resolver.js";

export class CommerceOrderRepository extends CommerceRepository {
    public async get(orderId: string, options: CommerceOperationOptions): Promise<CommerceOrder> {
        const response = await this.execute(
            getCommerceOrderOperation,
            { orderId },
            options,
            "order-operation-failed",
            "Teqtank Commerce could not load the Order.",
        );
        if (response.order === null) throw new Error(`Order '${orderId}' was not found.`);
        return resolveCommerceOrder(response.order);
    }
    public async refresh(
        orderId: string,
        options: CommerceOperationOptions,
    ): Promise<CommerceOrder> {
        const response = await this.execute(
            refreshCommerceOrderOperation,
            { orderId },
            options,
            "order-operation-failed",
            "Teqtank Commerce could not refresh the Order.",
        );
        if (response.order === null) throw new Error(`Order '${orderId}' was not found.`);
        return resolveCommerceOrder(response.order);
    }
}
